import { render, staticRenderFns } from "./DraggableUpload.vue?vue&type=template&id=84c70a1e&scoped=true&"
import script from "./DraggableUpload.vue?vue&type=script&lang=js&"
export * from "./DraggableUpload.vue?vue&type=script&lang=js&"
import style0 from "./DraggableUpload.vue?vue&type=style&index=0&id=84c70a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c70a1e",
  null
  
)

export default component.exports